import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BootstrapIconComponent } from './bootstrap-icon.component';

@NgModule({
    imports: [CommonModule],
    declarations: [BootstrapIconComponent],
    exports: [BootstrapIconComponent],
})
export class BootstrapIconModule {}
